'use strict'
import * as Helper from '../../helper.js'

const RegisterPractitioner =
{
	form: null,
	init: function (target)
	{
		if (!target.RegisterPractitioner)
		{
			RegisterPractitioner.form = document.querySelector('form[ui-action="registerhcp create"]')
			target.RegisterPractitioner = true
			Helper.formTrackValidity(target)

			target.addEventListener('reset', e =>
			{
				RegisterPractitioner.onReset(e.target)
			})

			target.addEventListener('input', e =>
			{
				if (e.target.name == 'website') RegisterPractitioner.onInput_Website(e.target)
			})

			target.addEventListener('change', e =>
			{
				if (e.target.name == 'accounttype') RegisterPractitioner.onChange_AccountType(e.target)
				else if (e.target.name == 'sameasmailingbillingaddress') Helper.elementToggle(e.target.form.querySelector('fieldset[name="shippingAddress"]'), !e.target.checked)
			})
		}
	},
	onChange_AccountType: function(el)
	{
		switch (el.value)
		{
			case 'corporation':
				Helper.elementToggle(el.form.querySelector('fieldset[name="license"]'), true)
				Helper.elementToggle(el.form.querySelector('fieldset[name="corporation"]'), true)
				Helper.elementToggle(el.form.querySelector('fieldset[name="student"]'), false)
				break
			case 'individualpractitioner':
				Helper.elementToggle(el.form.querySelector('fieldset[name="license"]'), true)
				Helper.elementToggle(el.form.querySelector('fieldset[name="corporation"]'), false)
				Helper.elementToggle(el.form.querySelector('fieldset[name="student"]'), false)
				break
			case 'student':
				Helper.elementToggle(el.form.querySelector('fieldset[name="license"]'), false)
				Helper.elementToggle(el.form.querySelector('fieldset[name="corporation"]'), false)
				Helper.elementToggle(el.form.querySelector('fieldset[name="student"]'), true)
				break
		}
	},
	onInput_Website: function (el)
	{
		if (el.value && !el.showingWebsiteOptions)
		{
			el.showingWebsiteOptions = true
			Helper.elementToggle(el.form.querySelector('fieldset[name="sellingOnWebsite"]'), true)
		}
		else if (!el.value && el.showingWebsiteOptions)
		{
			el.showingWebsiteOptions = false
			Helper.elementToggle(el.form.querySelector('fieldset[name="sellingOnWebsite"]'), false)
		}
	},
	onReset: function(el)
	{
		setTimeout(() =>
		{
			el.querySelector('[name=sameasmailingbillingaddress]').dispatchEvent(new Event('change'))
			el.querySelector('[name=accounttype]').dispatchEvent(new Event('change'))
			el.querySelector('[name=website]').dispatchEvent(new Event('input'))
		})
	}
}

document.addEventListener('view.render', e =>
{
	if (e.detail.view.model.view == 'register/practitioner')
	{
		RegisterPractitioner.init(e.target)
	}
})

export default RegisterPractitioner
